import { createContext } from "react";
const PincodeMasterContext = createContext({});

export default PincodeMasterContext;
